import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Avatar,
  Typography,
  Box,
  useMediaQuery,
  Button,
  Grid,
  Stack,
} from "@mui/material";
import { green } from "@mui/material/colors";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";
import {
  bgColor15,
  blackColor,
  blackShade05,
  blackShade159,
  blackShade19,
  borderTextBoxColor,
  greyColor060,
  greyColor11,
  greyColor28,
  greyColor29,
  greyColor53,
  greyColor8,
  lightBlueColor01,
  lightRedColor,
  logoImgborder1,
  orderCardBorder,
  redColor,
  whiteColor,
} from "../../configs/styles/muiThemes";
import { getActiveBusinessInfo } from "../../reducers/businessPreview/businessPreviewSlice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getDashboardOrderSummaryApi } from "../../service/api_calls/BusinessDashboard/BusinessDashboardApi";
import {
  clearCRMInfo,
  getAllBusinessCustomersData,
} from "../../reducers/crmcustomerdata/customerSlice";
import InfiniteScroll from "react-infinite-scroll-component";
import ThreeDotLoader from "../../components/ThreeDotLoader";
import ProfileCharAvatar from "../../components/ProfileCharAvatar";
import moment from "moment";
import LightToolTip from "../../components/Alerts/LightToolTip";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { addThousandsSeparator } from "../../utils/helper";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import TopOrdersByCityChartSection from "../OrderSummaryReport/Sections/TopOrdersByCityChartSection";
import { getOrderReportByCityData } from "../../reducers/orderSummary/orderSummarySlice";
import TopCustomerSection from "../OrderSummaryReport/Sections/TopCustomerSection";
import CRMTopCustomers from "./Sections/CRMTopCustomers";
import CRMTopOrdersByCityChartSection from "./Sections/CRMTopOrdersByCityChartSection";
import PeopleIcon from "@mui/icons-material/People";
import CRMSalesByAreaSection from "./Sections/CRMSalesByAreaSection";
import CRMTopSellingByAreaSection from "./Sections/CRMTopSellingByAreaSection";
import EmptyCard from "../../components/Alerts/EmptyCard";

const CRMAnalysisContent = ({ statsCountInfo }) => {
  const matches = useMediaQuery((theme) => theme.breakpoints.up("md"));

  const businessId = sessionStorage.getItem("selectedBusinessId");

  const { activeBusinessInfo, activeBusinessInfoLoader } = useSelector(
    (state) => state.businessPreview
  );

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const PAGE_SIZE = 100;
  const [hasMoreData, setHasMoreData] = useState(true);

  const {
    businessCustomers,
    businessCustomersPageNo,
    businessCustomersLoader,
  } = useSelector((state) => state.businessCustomers);

  const { orderReportByCity } = useSelector((state) => state.orderSummary);

  const crmcustomerdata = () => {
    const businessId = sessionStorage.getItem("selectedBusinessId");

    dispatch(
      getAllBusinessCustomersData({
        businessId,
        pageNo: businessCustomersPageNo + 1,
      })
    );
    console.log("businessCustomers123", businessCustomers);
  };
  const fetchNextData = () => {
    crmcustomerdata();
  };

  useEffect(() => {
    dispatch(getOrderReportByCityData(businessId));

    crmcustomerdata();
    return () => {
      dispatch(clearCRMInfo());
    };
  }, []);

  useEffect(() => {
    if (
      businessCustomersPageNo * PAGE_SIZE >
      businessCustomers?.details?.length
    ) {
      setHasMoreData(false);
    }
    return () => {};
  }, [businessCustomersPageNo]);

  return (
    <Box
      sx={{
        background: whiteColor,
        borderRadius: "12px",
        padding: "15px",
        mt: "20px",
      }}
    >
      <Box
        display="inline-flex"
        sx={{
          borderBottom: "0px solid #e7e8eb",
          borderRadius: "7px",
          background: "#f1f4f7",
          padding: "8px 12px",
          gap: 2,
        }}
      >
        <Button
          sx={{
            height: "35px",
            color: whiteColor,
            background: "#3f53d8",
            borderRadius: "5px",
            fontSize: "13px",
            fontWeight: 600,
            px: "15px",
            textTransform: "capitalize",
            "&:hover": {
              backgroundColor: "#3f53d8",
              color: whiteColor,
            },
          }}
        >
          CRM Analysis
        </Button>
      </Box>
      {/* {businessCustomersLoader ? (
        <ThreeDotLoader />
      ) :  */}
      {businessCustomers?.details?.length > 0 ? (
        <>
          <Grid container columnSpacing={4} mt={2}>
            <Grid item xs={4}>
              <Stack gap={"15px"}>
                <TotalOrderDetail
                  label={"Customer"}
                  value={
                    statsCountInfo?.orderCountInfo?.details?.totalBuyers || 0
                    // statsCountInfo?.orderCountInfo?.details?.recentOrderSummary
                    // ?.length > 0
                    // ? moment(
                    //     statsCountInfo?.orderCountInfo?.details
                    //       ?.recentOrderSummary[0]?.orderDate
                    //   ).format("Do MMM YYYY")
                    // : "N/A"
                  }
                  borderColor={`1px solid #e7daf5`}
                  bgColor={"#f9f3ff"}
                  icon={<PeopleIcon sx={{ fontSize: "26px", pr: 1 }} />}
                  iconColor={"#894bc9"}
                />
                <TotalOrderDetail
                  label={"Orders"}
                  value={
                    statsCountInfo?.orderCountInfo?.details?.totalOrders || 0
                  }
                  borderColor={`1px solid #ffdfed`}
                  bgColor={"#fff3f9"}
                  icon={
                    <Inventory2OutlinedIcon sx={{ fontSize: "26px", pr: 1 }} />
                  }
                  iconColor={"#c94b85"}
                />
                <TotalOrderDetail
                  label={"Sales"}
                  value={`₹ ${addThousandsSeparator(
                    statsCountInfo?.orderCountInfo?.details?.totalAmount
                  )}`}
                  borderColor={`1px solid #d3f8de`}
                  bgColor={"#f1fff5"}
                  icon={
                    <AccountBalanceWalletOutlinedIcon
                      sx={{ fontSize: "26px", pr: 1 }}
                    />
                  }
                  iconColor={"#13ccac"}
                />
              </Stack>
            </Grid>

            <Grid item xs={4}>
              {/* {orderReportByCity?.length > 0 && (
            <CRMTopOrdersByCityChartSection
              rawData={orderReportByCity?.slice(0, 5)}
            />
          )} */}
              <CRMSalesByAreaSection orderReportByCity={orderReportByCity} />
              {/* <CRMTopSellingByAreaSection /> */}
            </Grid>
            <Grid item xs={12} md={4}>
              <CRMTopCustomers businessCustomers={businessCustomers} />
            </Grid>
          </Grid>

          <Box sx={{ ...styles.card, border: `1px solid #E1E8F0` }} mt={3}>
            <Grid container columnSpacing={2}>
              <Grid item md={4}>
                <Typography sx={styles.headingCustomeInfo}>
                  {" "}
                  Customer Info
                </Typography>
              </Grid>
              <Grid item md={1.6}>
                <Typography sx={styles.headingCustomeInfo}>Phone No</Typography>
              </Grid>
              <Grid item md={1.6}>
                <Typography sx={styles.headingCustomeInfo}>
                  Last Order Date
                </Typography>
              </Grid>
              <Grid item md={1.6}>
                <Typography sx={styles.headingCustomeInfo}>
                  Last Order Value
                </Typography>
              </Grid>
              <Grid item md={1.6}>
                <Typography sx={styles.headingCustomeInfo}>
                  No. of Orders
                </Typography>
              </Grid>
              <Grid item md={1.6}>
                <Typography sx={styles.headingCustomeInfo}>
                  Total Order Value
                </Typography>
              </Grid>
            </Grid>
          </Box>
          <Box
            mt={1}
            id="scrollableDiv"
            height={
              "25vh"
              // statsCountInfo?.orderCountInfo?.details?.totalOrders === 0
              //   ? "30vh"
              //   : filterCount.length > 0
              //   ? orderdata?.details?.length > 0
              //     ? "47vh"
              //     : "30vh"
              //   : "53vh"
            }
            sx={{
              overflowY: "scroll",
              scrollbarWidth: "thin",
              "&::-webkit-scrollbar": {
                width: "6px",
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#e5e9f0",
                borderRadius: "4px",
              },
              "&::-webkit-scrollbar-track": {
                backgroundColor: "transparent",
              },
            }}
          >
            {businessCustomers?.details?.length > 0 && (
              <InfiniteScroll
                dataLength={businessCustomers?.details?.length || 0}
                next={fetchNextData}
                hasMore={hasMoreData}
                loader={
                  <Box>
                    <ThreeDotLoader />
                  </Box>
                }
                scrollableTarget="scrollableDiv"
              >
                {businessCustomers?.details?.map((item, index) => {
                  const onBoardedDate = item?.createdOn;
                  const lastPurchasedDate = item.orderInfo?.lastTxnDate;

                  const userInfo = businessCustomers?.profileInfo?.filter(
                    (profile) =>
                      item.contactInfo?.profileId === profile.profileId
                  );

                  let username = "";
                  let profilePic = "";

                  if (userInfo?.length > 0) {
                    username = userInfo?.[0]?.name;
                    profilePic = userInfo?.[0]?.photoUrl;
                  }
                  return (
                    <Box
                      sx={{
                        ...styles.cardInfo,
                        backgroundColor: whiteColor,
                        // border: `1px solid #E1E8F0`,
                      }}
                    >
                      <Grid
                        container
                        spacing={2}
                        key={index}
                        alignItems={"center"}
                      >
                        <Grid item md={4}>
                          <Typography sx={styles.headingCustomeInfo}>
                            <Box display="flex" alignItems="center" gap={2}>
                              <ProfileCharAvatar
                                username={item.contactInfo?.name || "Guest"}
                                border
                                size={matches ? "33px" : "43px"}
                                fontSize={11.5}
                              />
                              <Box>
                                <LightToolTip
                                  title={item.contactInfo?.name}
                                  placement="top"
                                >
                                  <Typography sx={styles?.productInfoText}>
                                    {item.contactInfo?.name.length > 20
                                      ? `${item.contactInfo?.name.slice(
                                          0,
                                          20
                                        )}...`
                                      : item.contactInfo?.name}
                                  </Typography>
                                </LightToolTip>
                                <Typography variant="body2" color={bgColor15}>
                                  Customer since{" "}
                                  {moment(onBoardedDate).format("MMM DD YYYY")}
                                </Typography>
                              </Box>
                            </Box>
                          </Typography>
                        </Grid>
                        <Grid item md={1.6}>
                          <Box display="flex" alignItems="center" gap={1}>
                            <PhoneIcon
                              sx={{ fontSize: "16px", color: blackShade19 }}
                            />
                            <Typography
                              sx={{
                                ...styles?.productInfoText,
                                color: greyColor060,
                                fontWeight: 400,
                              }}
                              // color={greyColor060}
                            >
                              +91{" "}
                              {item.contactInfo?.phone.slice(3) ||
                                item.contactInfo?.originalContact}
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item md={1.6}>
                          <Typography fontSize={12} color={greyColor060}>
                            {moment(item?.createdOn).format("MMM DD, YYYY")}
                          </Typography>
                        </Grid>
                        <Grid item md={1.6}>
                          <Typography
                            fontSize={12}
                            fontWeight={600}
                            color={blackShade19}
                          >
                            ₹{" "}
                            {addThousandsSeparator(
                              item.orderInfo?.lastTxnAmount
                            )}
                          </Typography>
                        </Grid>
                        <Grid item md={1.6}>
                          <Box
                            sx={{
                              display: "inline-block",
                              // p: "7px 8px",
                              padding: "0px 10px",
                              bgcolor: "#ceebcfb5",
                              // p: "2px 6px",
                              borderRadius: 1,
                              textAlign: "center",
                            }}
                          >
                            <Typography
                              fontSize={12}
                              fontWeight={600}
                              color="#039300"
                            >
                              {item.orderInfo?.totalOrder}
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item md={1.6}>
                          <Box
                            sx={{
                              display: "inline-block",
                              bgcolor: "#fbf4e6",
                              // p: "7px 8px",
                              padding: "0px 10px",
                              borderRadius: 1,
                              textAlign: "center",
                            }}
                          >
                            <Typography
                              fontSize={12}
                              fontWeight={600}
                              color="#ff7800"
                            >
                              ₹{" "}
                              {addThousandsSeparator(
                                item?.orderInfo?.totalAmount
                              )}
                            </Typography>
                          </Box>
                        </Grid>
                      </Grid>
                    </Box>
                  );
                })}
              </InfiniteScroll>
            )}
          </Box>
        </>
      ) : 
        businessCustomersLoader ? <ThreeDotLoader /> :
        <Box mt={2}>
          <EmptyCard
            icon={"/./assets/icon/crm-empty.svg"}
            iconWidth={"98px"}
            iconHeight={"85px"}
            message={"Customer Details not available"}
            hideBtn
            margin
            paddingY={"30px"}
          />
        </Box>
      }
    </Box>
  );
};

export default CRMAnalysisContent;

function TotalOrderDetail({
  label,
  value,
  hideLabel,
  borderColor,
  bgColor,
  icon,
  iconColor,
}) {
  return (
    <Box
      sx={{
        background: bgColor,
        border: borderColor,
        width: "100%",
        display: "flex",
        alignItems: "center",
        padding: "8px 13px",
        borderRadius: "10px",
      }}
    >
      <Box
        sx={{
          width: "35px",
          height: "35px",
          position: "relative",
          color: "#ffffff",
          background: iconColor,
          border: "1px solid #fff",
          borderRadius: "8px",
          lineHeight: "27px",
          padding: "3px 8px",
          textAlign: "center",
          marginRight: "10px",
        }}
      >
        {icon}
      </Box>
      <Box>
        {!hideLabel ? (
          <Typography
            variant="h3"
            fontSize={{ xs: 12, md: 12 }}
            color={greyColor060}
            fontWeight={400}
            lineHeight={1.5}
          >
            {label}{" "}
          </Typography>
        ) : (
          <Box sx={{ height: "22px" }} />
        )}

        <Typography
          variant="body1"
          fontSize={{ xs: 12.5, md: 14 }}
          color={blackColor}
          fontWeight={600}
        >
          {value}
        </Typography>
      </Box>
      {/* <Box
        component="img"
        maxHeight={{ xs: "29px", md: "40px" }}
        src={}
        alt="CostBo"
      /> */}
    </Box>
  );
}

const styles = {
  card: {
    display: { md: "flex", xs: "none" },
    flexDirection: { xs: "column", md: "row" },
    gap: { xs: "16px", md: "20px" },
    backgroundColor: greyColor53,
    // backgroundColor: greyColor42,
    border: orderCardBorder,
    borderRadius: "7px 7px 0px 0px",
    boxShadow: "0 2px 4px rgb(179 188 198 / 5%)",
    padding: "7px 15px",
    position: "sticky",
    top: 150,
    zIndex: 10000,
    // marginBottom: "15px",
  },
  cardInfo: {
    display: { md: "flex", xs: "none" },
    flexDirection: { xs: "column", md: "row" },
    gap: { xs: "16px", md: "20px" },
    backgroundColor: whiteColor,
    // backgroundColor: greyColor42,
    border: orderCardBorder,
    // borderRadius: "7px 7px 0px 0px",
    // boxShadow: "0 2px 4px rgb(179 188 198 / 5%)",
    padding: "7px 15px",
    // position: "sticky",
    // top: 150,
    // zIndex: 10000,
    // marginBottom: "15px",
  },

  orderIdText: {
    fontSize: { md: 13, xs: 13 },
    fontWeight: 500,
    lineHeight: "20px",
    color: blackShade05,
    display: "inline",
  },

  orderInfoBox: {
    display: "flex",
    flexDirection: { md: "row", xs: "column" },
    alignItems: { md: "flex-end", xs: "flex-start" },
    justifyContent: "space-between",
    borderRadius: "12px",
    border: `1px solid ${greyColor28}`,
    p: "13px 15px 13px 15px",
    mt: 2.2,
    position: "relative",
  },
  headingCustomeInfo: {
    color: greyColor060,
    fontSize: "12px",
    fontWeight: "400",
    // whiteSpace: "nowrap",
  },
  tableCell: {
    color: greyColor060,
    fontSize: "12px",
    fontWeight: "400",
    whiteSpace: "nowrap",
    padding: "8px 15px",
    // backgroundColor: greyColor060,
    // borderRight: `1px solid ${whiteColor}`,
  },

  tableBodyCell: (isError) => ({
    fontSize: 12,
    fontWeight: 400,
    whiteSpace: "nowrap",
    color: blackShade19,
    backgroundColor: isError ? lightRedColor : whiteColor,
    padding: "8px 15px !important",
    //   borderRight: `1px solid ${borderTextBoxColor}`,

    //   boxShadow: isError ? `0px -1px 0 0 ${redColor} inset` : "none",
  }),

  productInfoText: {
    fontSize: "12px",
    color: blackShade19,
    fontWeight: 600,
    lineHeight: "16px",
  },

  statusTag: (bgColor) => ({
    position: "absolute",
    right: 0,
    top: "10%",
    backgroundColor: bgColor || lightBlueColor01,
    fontSize: 12,
    fontWeight: 500,
    lineHeight: "20px",
    color: whiteColor,
    p: "0 15px 0 20px",
    // position: "relative",

    "&::before": {
      content: '" "',
      width: "15px",
      height: "28px",
      backgroundColor: whiteColor,
      rotate: "40deg",
      position: "absolute",
      left: -3,
      top: -8,
    },
  }),

  table: {
    border: `1px solid ${greyColor11}`,
    borderRadius: "7px",
    mt: 3,
  },

  tableHeader: {
    backgroundColor: greyColor53,
    p: "10px 4px 10px 15px",
    borderRadius: "7px 7px 0 0",
  },

  tableHeaderText: {
    fontSize: 12,
    fontWeight: 600,
    color: greyColor29,
  },
  productRow: {
    p: "10px 4px 10px 15px",
    borderBottom: "1px solid #f2f2f2",
  },

  productImg: {
    width: { md: "36.12px", xs: 35 },
    height: { md: "40px", xs: 40 },
    borderRadius: "8px",
    border: logoImgborder1,
  },

  centerText: {
    height: "100%",
    display: "flex",
    alignItems: { md: "center", xs: "flex-start" },
    justifyContent: "flex-start",
  },

  summaryCard: {
    padding: "12px",
    border: `1px solid ${greyColor28}`,
    borderRadius: "12px",
    // mt: { md: 2.2, xs: "none" },
    // mb: { md: "none", xs: 2.2 },
  },

  actionBtn: (color) => ({
    padding: { md: "3px 6px", xs: "3px 15px" },
    fontSize: "12px",
    fontWeight: 500,
    color: color || greyColor8,
    backgroundColor: whiteColor,
    border: color ? "1px solid " + color : "1px solid" + greyColor8,
    "&:hover": {
      color: whiteColor,
      backgroundColor: color || greyColor8,
    },
    "&.Mui-disabled": {
      borderColor: "rgba(0,0,0,0.2)",
    },
  }),
};
